import React from 'react';

/**
 * Eventbrite Brand Word mark
 * @returns SVG
 */
export const EBWordmark: React.FunctionComponent = () => (
  <svg
    width="109%"
    height="70%"
    viewBox="0 0 200 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_36_185)">
      <path
        d="M70.7362 10.1123L67.214 20.1407H67.0672L63.5532 10.1123H57.3894L63.4065 26.2556H70.4019L76.4189 10.1123H70.7362Z"
        fill="#F05537"
      />
      <path
        d="M104.172 9.67212C101.743 9.67212 99.8185 10.7565 98.9543 12.5339V10.1124H93.084V26.2638H98.9543V18.3308C98.9543 15.9011 99.7533 14.3113 101.743 14.3113C103.52 14.3113 104.14 15.469 104.14 17.6785V26.2557H110.01V16.1213C110.01 12.754 108.591 9.67212 104.172 9.67212Z"
        fill="#F05537"
      />
      <path
        d="M148.933 12.9743V10.1125H143.063V26.2639H148.933V18.8772C148.933 16.1622 150.279 14.9881 152.447 14.9881C153.572 14.9881 154.804 15.2082 155.603 15.6811V10.137C155.203 9.81085 154.331 9.51733 153.352 9.51733C151.216 9.51733 149.512 11.1643 148.933 12.9743Z"
        fill="#F05537"
      />
      <path d="M162.451 10.1123H156.581V26.2637H162.451V10.1123Z" fill="#F05537" />
      <path
        d="M159.516 8.97921C161.349 8.97921 162.834 7.49354 162.834 5.66087C162.834 3.8282 161.349 2.34253 159.516 2.34253C157.683 2.34253 156.198 3.8282 156.198 5.66087C156.198 7.49354 157.683 8.97921 159.516 8.97921Z"
        fill="#F05537"
      />
      <path
        d="M171.42 20.0592V14.1563H175.627V10.1042H171.42V5.65259H167.898C167.898 8.11485 165.9 10.1042 163.438 10.1042V14.1563H165.615V21.7551C165.615 25.5626 168.183 26.6796 170.906 26.6796C173.116 26.6796 174.526 26.1334 175.765 25.2284V21.429C174.787 21.8285 173.988 21.9752 173.27 21.9752C172.072 21.9834 171.42 21.4371 171.42 20.0592Z"
        fill="#F05537"
      />
      <path
        d="M120.307 21.9834C120.299 21.9834 120.299 21.9834 120.291 21.9834C119.101 21.9834 118.457 21.4371 118.457 20.0674V14.1645H122.664V10.1042H118.457V5.65259H114.935C114.935 8.11485 112.937 10.1042 110.475 10.1042C110.475 10.1042 110.475 10.1042 110.467 10.1042V14.1563H112.643V21.7551C112.643 25.5626 115.212 26.6796 117.935 26.6796C120.144 26.6796 121.555 26.1334 122.794 25.2284V21.429C121.824 21.8285 121.025 21.9834 120.307 21.9834Z"
        fill="#F05537"
      />
      <path
        d="M50.3451 9.68018C45.3146 9.68018 41.5478 13.3409 41.5478 18.4448C41.5478 23.5895 45.2412 26.704 50.4185 26.704C55.1229 26.704 57.9357 24.2499 58.6043 20.5076H53.7857C53.2395 21.7713 52.2285 22.3176 50.6386 22.3176C48.8612 22.3176 47.4181 21.38 47.2714 19.3824H58.6043V17.7518C58.5961 13.3736 55.7343 9.68018 50.3451 9.68018ZM47.3366 16.5615C47.5567 15.0368 48.3883 13.8791 50.2717 13.8791C52.0083 13.8791 52.9541 15.1102 53.0275 16.5615H47.3366Z"
        fill="#F05537"
      />
      <path
        d="M83.7894 9.68018C78.7589 9.68018 74.9921 13.3409 74.9921 18.4448C74.9921 23.5895 78.6855 26.704 83.8628 26.704C88.5672 26.704 91.38 24.2499 92.0486 20.5076H87.23C86.6838 21.7713 85.6728 22.3176 84.0829 22.3176C82.3055 22.3176 80.8624 21.38 80.7157 19.3824H92.0486V17.7518C92.0486 13.3736 89.1868 9.68018 83.7894 9.68018ZM80.7809 16.5615C81.001 15.0368 81.8326 13.8791 83.716 13.8791C85.4526 13.8791 86.3984 15.1102 86.4718 16.5615H80.7809Z"
        fill="#F05537"
      />
      <path
        d="M193.523 17.7518C193.523 13.3736 190.661 9.68018 185.264 9.68018C180.233 9.68018 176.467 13.3409 176.467 18.4448C176.467 23.5895 180.16 26.704 185.337 26.704C190.042 26.704 192.854 24.2499 193.523 20.5076H188.704C188.158 21.7713 187.147 22.3176 185.557 22.3176C183.78 22.3176 182.337 21.38 182.19 19.3824H193.523V17.7518ZM182.263 16.5615C182.484 15.0368 183.315 13.8791 185.199 13.8791C186.935 13.8791 187.881 15.1102 187.954 16.5615H182.263Z"
        fill="#F05537"
      />
      <path
        d="M134.983 9.64772C132.268 9.64772 130.45 10.9522 129.651 12.8764V3.4187H123.781V26.2557H128.314L129.325 23.4673C130.23 25.4241 132.26 26.696 134.869 26.696C139.728 26.696 142.158 22.9619 142.158 18.1759C142.158 13.4145 139.728 9.64772 134.983 9.64772ZM132.92 22.1547C130.923 22.1547 129.659 20.63 129.659 18.2738V18.0618C129.659 15.7381 130.931 14.2217 132.92 14.2217C135.203 14.2217 136.255 15.8523 136.255 18.1759C136.255 20.5241 135.203 22.1547 132.92 22.1547Z"
        fill="#F05537"
      />
      <path
        d="M30.6878 23.932L19.8685 15.5017C19.6892 15.363 19.8767 15.0858 20.0724 15.2L24.2957 17.5644C26.2117 18.6406 28.6332 18.0128 29.791 16.1539C31.0139 14.189 30.3698 11.6044 28.3641 10.4467L22.1677 6.86744C21.9721 6.7533 22.1188 6.45163 22.3308 6.54132L25.1763 7.68276C25.1844 7.68276 25.2496 7.70722 25.2741 7.71537C25.5758 7.82136 25.9019 7.87844 26.2362 7.87844C27.7771 7.87844 29.049 6.65546 29.155 5.2042C29.2936 3.31266 27.8587 2 26.1383 2H12.9791C11.2914 2 9.8646 3.37789 9.88906 5.06559C9.89722 5.96244 10.3049 6.76145 10.9327 7.30771C11.4056 7.72353 13.0036 8.99542 13.7618 9.60691C13.9004 9.7129 13.8189 9.93304 13.6477 9.93304H11.0142C8.24212 9.94934 6 12.1996 6 14.9717C6 16.374 6.57072 17.6378 7.50018 18.5591L22.7548 33.0554C23.831 34.0583 25.2822 34.6779 26.8721 34.6779C30.2149 34.6779 32.9218 31.9711 32.9218 28.6283C32.9136 26.7367 32.0494 25.0409 30.6878 23.932Z"
        fill="#F05537"
      />
    </g>
    <defs>
      <clipPath id="clip0_36_185">
        <rect width="187.523" height="32.6779" fill="white" transform="translate(6 2)" />
      </clipPath>
    </defs>
  </svg>
);
